export const defaultValue = {
    id: '',
    name: '',
    email: '',
    phone: '',
    status: 'active',
    skills: [],
    availability: true,
    createdAt: null,
    updatedAt: null,
};
